<div class="container-fluid" *ngIf="pnr">
  <div class="row">
    <div class="col-12 text-right text-pnr">
      <span *ngIf="supplierName">{{ 'ITINERARY.SUPPLIER' | translate }}:&nbsp;<span class="text-success">{{ supplierName }}</span><br></span>
      {{ 'ITINERARY.PNR' | translate }}:&nbsp;<span class="text-success">{{ pnr }}</span>
    </div>
  </div>
</div>